export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, Alert, DirectoriesResource) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
        this.$conConfig = angular.copy(this.conConfig);
    }

    saveConfig() {
        console.log('save config');
        this.isSaving = true;
        this.DirectoriesResource.updateScimConfig(
            this.companyId,
            this.directoryId,
            this.conConfig
        )
        .then(() => {
            this.$conConfig = angular.copy(this.conConfig);
            this.Alert('success', 'company.directory-integration.manage.connection.tenant-parameters.updated');
            this.$state.go('.', {}, {reload: '.'});

        })
        .catch((error) => {
            this.Alert('danger', error.data.message);
        })
        .finally(() => this.isSaving = false);
    }

    testConnectionEnabled() {
        let config = this.$conConfig;
        return config.tenantId && config.baseUrl && config.connectionType && (config.accessToken || config.connectionType != 'BEARER_TOKEN') 
        && (config.tokenEndpoint && config.clientId && config.clientSecret || config.connectionType != 'OAUTH2_CLIENT_CREDENTIALS')
        && (config.clientId && config.clientSecret || config.connectionType != 'BASIC_AUTHENTICATION');
    }

    testConnection() {
        this.isTestingConnection = true;
        this.DirectoriesResource.testScimConnection(
            this.companyId,
            this.directoryId
        )
        .then((data) => {
            this.Alert('success', 'company.directory-integration.manage.connection.test.success');
        })
        .catch((error) => {
            this.Alert('danger', 'company.directory-integration.manage.connection.test.failed');
        })
        .finally(() => this.isTestingConnection = false);
    }

    configIsNotModified() {
        return angular.equals(this.$conConfig, this.conConfig);
    }

    resetConfig() {
        this.conConfig = angular.copy(this.$conConfig);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/scim/connection/directory-manage-connection-scim.controller.js